<template>
  <div :class="['page-title', subTitle !== '' ? '-has-sub-title' : '']">
    <component
      :is="heading"
      class="page-title"
    >
      {{ title }}
      <slot name="after-title" />
    </component>
    <p
      v-if="subTitle !== ''"
      class="_sub-title"
      :style="['h1', 'h2'].includes(heading) ? { margin: '1.4rem 0' } : { margin: '0 0 .6rem' } "
    >
      {{ subTitle }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: 'h1',
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .page-title {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      display: flex;
      align-items: center;
      margin-top: 0;
    }

    h6 {
      font-weight: normal;
    }

    &.-has-sub-title {
      h1 {
        margin-bottom: 1rem;
      }

      h2,
      h3,
      h4 {
        margin-bottom: .4rem;
      }
    }

    ._sub-title {
      color: $font-color-secondary;
    }
  }
</style>
